export default {
  descriptionText: {
    '&::selection': { background: 'white' }
  },
  clampThree: {
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    fontSize: '1.8rem',
    lineHeight: '1.4',
    '-webkit-line-clamp': 3,
    minHeight: '3rem'
  },
  exportContainer: {
    display: 'flex',
    flexDirection: 'column',
    fontWeight: 300,
    '& strong': { fontWeight: 400 }
  }
}



// WEBPACK FOOTER //
// ./src/components/DeviceDescription/DescriptionBuilder/style.js